(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-sticky-bar]');
    if (!bar) return;

    var mainCta = document.querySelector('.levive-pdp__cta');
    if (!mainCta) return;

    var stickyLabel = bar.querySelector('[data-sticky-cta-label]');
    var stickyPrice = bar.querySelector('[data-sticky-cta-price]');
    var stickyMeta = bar.querySelector('[data-sticky-meta]');
    var stickyCta = bar.querySelector('[data-sticky-cta]');
    var stickyPlanWrap = bar.querySelector('[data-sticky-plan-wrap]');
    var stickyPlanBtn = bar.querySelector('[data-sticky-plan-btn]');
    var stickyPlanLabel = bar.querySelector('[data-sticky-plan-label]');
    var stickyPlanList = bar.querySelector('[data-sticky-plan-list]');
    var widget = document.querySelector('.levive-pdp__widget');
    var currentPlanValue = null;

    if (stickyPlanList && widget) {
      widget.querySelectorAll('.levive-pdp__option').forEach(function (option) {
        var titleEl = option.querySelector('.levive-pdp__option-title');
        if (!titleEl) return;
        var value = option.getAttribute('data-option');
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-sticky-bar__plan-option';
        btn.setAttribute('data-plan-value', value);
        btn.textContent = titleEl.textContent.trim();
        if (option.classList.contains('is-active')) {
          btn.classList.add('is-active');
          currentPlanValue = value;
          if (stickyPlanLabel) stickyPlanLabel.textContent = titleEl.textContent.trim();
        }
        btn.addEventListener('click', function () {
          var targetInput = widget.querySelector('[data-option="' + value + '"] [data-option-input]');
          if (targetInput) targetInput.click();
          stickyPlanWrap.classList.remove('is-open');
        });
        li.appendChild(btn);
        stickyPlanList.appendChild(li);
      });
      stickyPlanWrap.style.display = '';
    }

    if (stickyPlanBtn) {
      stickyPlanBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stickyPlanWrap.classList.toggle('is-open');
      });
    }

    document.addEventListener('click', function () {
      if (stickyPlanWrap) stickyPlanWrap.classList.remove('is-open');
    });

    function sync() {
      var mainLabel = document.querySelector('[data-cta-label]');
      var mainPrice = document.querySelector('[data-cta-price]');
      if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
      if (mainPrice && stickyPrice) stickyPrice.textContent = mainPrice.textContent;

      var activePerUnit = document.querySelector('.levive-pdp__option.is-active .levive-pdp__option-per-unit');
      if (activePerUnit && stickyMeta) stickyMeta.textContent = activePerUnit.textContent.trim();

      if (stickyPlanList && widget) {
        var activeOption = widget.querySelector('.levive-pdp__option.is-active');
        if (activeOption) {
          var val = activeOption.getAttribute('data-option');
          var titleEl = activeOption.querySelector('.levive-pdp__option-title');
          if (stickyPlanLabel && titleEl) stickyPlanLabel.textContent = titleEl.textContent.trim();
          stickyPlanList.querySelectorAll('[data-plan-value]').forEach(function (btn) {
            btn.classList.toggle('is-active', btn.getAttribute('data-plan-value') === val);
          });
        }
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var ctaAboveViewport = entry.boundingClientRect.top < 0;
        var shouldShow = !entry.isIntersecting && ctaAboveViewport;
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      });
    }, { threshold: 0 });

    observer.observe(mainCta);

    document.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', sync);
      input.addEventListener('click', sync);
    });

    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        var mainSubmit = document.querySelector('[data-product-form] [type="submit"]');
        if (mainSubmit) mainSubmit.click();
      });
    }

    // Mobile dropdown ATC
    var mobileAtc = bar.querySelector('[data-sticky-mobile-atc]');
    var mobileBtn = bar.querySelector('[data-sticky-mobile-btn]');
    var mobileList = bar.querySelector('[data-sticky-mobile-list]');

    if (mobileAtc && mobileBtn && mobileList && widget) {
      widget.querySelectorAll('.levive-pdp__option').forEach(function (option) {
        var value = option.getAttribute('data-option');
        var titleEl = option.querySelector('.levive-pdp__option-title');
        var priceEl = option.querySelector('.levive-pdp__option-price');
        if (!titleEl) return;
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-sticky-bar__plan-option';
        if (option.classList.contains('is-active')) btn.classList.add('is-active');
        btn.textContent = titleEl.textContent.trim() + (priceEl ? ' · ' + priceEl.textContent.trim() : '');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var targetInput = widget.querySelector('[data-option="' + value + '"] [data-option-input]');
          if (targetInput) targetInput.click();
          mobileList.querySelectorAll('.pdp-sticky-bar__plan-option').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          mobileAtc.classList.remove('is-open');
          var mainSubmit = document.querySelector('[data-product-form] [type="submit"]');
          if (mainSubmit) mainSubmit.click();
        });
        li.appendChild(btn);
        mobileList.appendChild(li);
      });

      mobileBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        mobileAtc.classList.toggle('is-open');
      });

      document.addEventListener('click', function () {
        mobileAtc.classList.remove('is-open');
      });
    }

    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-tab-ingredient-profile"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pdp-tab-ingredient-profile__intro-accordions').forEach(function(group) {
    group.addEventListener('toggle', function(e) {
      if (!e.target.open) return;
      group.querySelectorAll('details[open]').forEach(function(item) {
        if (item !== e.target) item.removeAttribute('open');
      });
    }, true);
  });
  } catch(e) { console.error(e); }
})();

})();
